module.exports = __webpack_public_path__ + "static/media/aria_english_newzeland.18bc21a0.mp3";